import { SettingsContext } from "../providers/SettingsProvider";
import { useContext } from "react";

export default function useSettingsContext() {
  return useContext(SettingsContext);
}
